// src/pages/Home/Home.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./Home.css";

import { useTranslation } from "../../i18n/TranslationContext";

import SoonPopup from "./ui/SoonPopup";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

import HeroSection from "./sections/HeroSection";
import AchievementsSection from "./sections/AchievementsSection";
import AboutSection from "./sections/AboutSection";
import AppSection from "./sections/AppSection";
import AwarenessSection from "./sections/AwarenessSection";
import TeamSection from "./sections/TeamSection";
import PricingSection from "./sections/PricingSection";
import { getFounders } from "./data/founders";

export default function Home() {
  const { t, lang, toggleLang } = useTranslation();

  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "dark",
  );
  const [soonOpen, setSoonOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("theme", theme);

    document.body.classList.remove("theme-light", "theme-dark");
    document.body.classList.add(`theme-${theme}`);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleDownloadApp = () => {
    setSoonOpen(true);
    window.clearTimeout(handleDownloadApp._t);
    handleDownloadApp._t = window.setTimeout(() => setSoonOpen(false), 1600);
  };

  const founders = useMemo(() => getFounders(lang), [lang]);

  return (
    <div
      className={`aq-home theme-${theme}`}
      dir={lang === "ar" ? "rtl" : "ltr"}
      lang={lang}
    >
      <SoonPopup open={soonOpen} lang={lang} />

      <Header
        theme={theme}
        lang={lang}
        t={t}
        onToggleTheme={toggleTheme}
        onToggleLang={toggleLang}
        onDownload={handleDownloadApp}
        onScroll={scrollToId}
      />
      <HeroSection t={t} lang={lang} onDownload={handleDownloadApp} />

      <AchievementsSection lang={lang} />

      <AboutSection t={t} />

      <AppSection
        t={t}
        lang={lang}
        theme={theme}
        onDownload={handleDownloadApp}
      />
      <PricingSection lang={lang} onDownload={handleDownloadApp} />

      <AwarenessSection t={t} lang={lang} />

      <TeamSection lang={lang} founders={founders} />

      <Footer lang={lang} t={t} onScroll={scrollToId} />
    </div>
  );
}
